export default __webpack_public_path__ + "static/media/OGJ-Type-Design-Sequel-Sans-Bold-Head.7993491f.woff";